var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lead-time-container" },
    [
      _vm._l(_vm.validator.leadTimes.$each.$iter, function (c, index) {
        return [
          _c(
            "div",
            {
              key: "lead-time-wrapper-" + index,
              staticClass: "lead-time-item",
            },
            [
              _c("TimeSpanInput", {
                attrs: {
                  value: c.$model,
                  "show-hours": false,
                  "show-minutes": false,
                  "show-seconds": false,
                  validator: c,
                },
                on: {
                  changed: function ($event) {
                    return _vm.handleTimeDelayChanged(index, $event)
                  },
                },
              }),
              _c(
                "md-button",
                {
                  staticClass: "md-danger md-just-icon md-round remove-button",
                  attrs: { title: "Remove value" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.removeValue(index)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
        ]
      }),
      _vm.values.length < _vm.maxItems
        ? _c(
            "div",
            { staticClass: "condition-button-wrapper" },
            [
              _c(
                "md-button",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.addValue($event)
                    },
                  },
                },
                [_vm._v("Add value")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }